module.exports = {
  "dof-tag": {
    "height": "72",
    "borderRadius": "36",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "dof-tag--normal": {
    "backgroundColor": "#f2f2f2"
  },
  "dof-tag--active": {
    "backgroundColor": "#00A4F2"
  },
  "dof-tag-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "fontWeight": "400"
  },
  "dof-tag-text--normal": {
    "color": "#616C73"
  },
  "dof-tag-text--active": {
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-d5874612!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-tag/index.vue
// module id = 542
// module chunks = 0 1